import { Component, inject } from '@angular/core';
import { UilabMatButton, UilabMatSnackBar } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface SnackbarExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly previewText: string;
    readonly actionLabel?: string;
}

@Component({
    selector: 'avd-snackbar-examples',
    templateUrl: './snackbar-examples.component.html',
    styleUrls: ['./snackbar-examples.component.scss'],
    imports: [CodeExampleHeaderComponent, CodeExampleComponent, UilabMatButton],
})
export class SnackbarExamplesComponent {
    private readonly snackBar = inject(UilabMatSnackBar);

    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/story/components-snack-bar--default`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/snack-bar`;

    readonly examples: readonly SnackbarExample[] = [
        {
            variant: 'basic',
            label: 'Basic Snackbar',
            description: 'A simple snackbar message with automatic dismissal.',
            htmlSnippet: `// In your component:
constructor(private snackBar: UilabMatSnackBar) {}

showSnackbar() {
  this.snackBar.open('Message archived');
}`,
            previewText: 'Show Basic Snackbar',
        },
    ];

    showSnackbar(variant: 'basic'): void {
        switch (variant) {
            case 'basic':
                this.snackBar.open('Message archived');
                break;
        }
    }
}
